const getAuthToken = () => {
  try {
    const tokenData = sessionStorage.getItem("authToken") || localStorage.getItem("authToken");
    if (!tokenData) return null;
    try {
      const parsed = JSON.parse(tokenData);
      return parsed.access || parsed.access_token || parsed.token;
    } catch {
      // Token is a raw JWT string, not JSON
      return tokenData;
    }
  } catch (e) {
    console.error("Error retrieving auth token:", e);
  }
  return null;
};

export const getLegalAwarenessZone = async (id: string) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_awareness/distributed-zones/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        console.log(response);
        throw new Error("Failed to get Legal Awareness request");
    }
    return response.json();
};

export const updateLegalAwarenessZone = async (id: string, data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_awareness/distributed-zones/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "PATCH",
            body: data,
        }
    );
    if (!response.ok) {
        console.log(response);
        throw new Error("Failed to get Legal Awareness request");
    }
    return response.json();
};

export const getLegalAwarenessZoneByAdminUnit = async (id: string) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_awareness/distributed-zones/filter-by-admin-unit/?admin_unit=${id}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        console.log(response);
        throw new Error("Failed to get Legal Awareness request");
    }
    return response.json();
};

export const getLegalAwareness = async () => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_awareness/legal-awareness/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        console.log(response);
        throw new Error("Failed to get Legal Awareness request");
    }
    return response.json();
};

export const getLegalAwarenessByProsecutor = async (prosecutorId: string) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_awareness/legal-awareness/by-prosecutor/?prosecutor_id=${prosecutorId}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        console.log(response);
        throw new Error("Failed to get Legal Awareness request");
    }
    return response.json();
};

export const getSingleLegalAwareness = async (id: string) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_awareness/legal-awareness/${id}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        console.log(response);
        throw new Error("Failed to get Legal Awareness request");
    }
    return response.json();
};

export const createLegalAwareness = async (data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_awareness/legal-awareness/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: data,
        }
    );
    if (!response.ok) {
        console.log(response);
        throw new Error("Failed to create Legal Awareness request");
    }
    return response.json();
};

export const updateLegalAwareness = async (id: string, data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_awareness/legal-awareness/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "PATCH",
            body: data,
        }
    );
    if (!response.ok) {
        console.log(response);
        throw new Error("Failed to create Legal Awareness request");
    }
    return response.json();
};

export const getLegalAwarenessTargetAudience = async () => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_awareness/target-audiences/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        console.log(response);
        throw new Error("Failed to get Legal Awareness request");
    }
    return response.json();
};

export const createLegalAwarenessTargetAudience = async (data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_awareness/target-audiences/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: data,
        }
    );
    if (!response.ok) {
        console.log(response);
        throw new Error("Failed to create Legal Awareness request");
    }
    return response.json();
};

export const createLegalAwarenessProsecutorAssignment = async (data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_awareness/assignments/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: data,
        }
    );
    if (!response.ok) {
        console.log(response);
        throw new Error("Failed to create Legal Awareness request");
    }
    return response.json();
};

export const updateLegalAwarenessProsecutorAssignment = async (id: string | number, data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_awareness/assignments/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "PATCH",
            body: data,
        }
    );
    if (!response.ok) {
        console.log(response);
        throw new Error("Failed to update Legal Awareness assignment");
    }
    return response.json();
};

export const deleteLegalAwarenessProsecutorAssignment = async (id: string | number) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_awareness/assignments/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "DELETE",
        }
    );
    if (!response.ok) {
        console.log(response);
        throw new Error("Failed to delete Legal Awareness assignment");
    }
    return response.ok;
};

export const createLegalAwarenessSchedule = async (data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_awareness/schedules/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: data,
        }
    );
    if (!response.ok) {
        console.log(response);
        throw new Error("Failed to create Legal Awareness request");
    }
    return response.json();
};

export const updateLegalAwarenessSchedule = async (id: string, data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_awareness/schedules/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "PATCH",
            body: data,
        }
    );
    if (!response.ok) {
        console.log(response);
        throw new Error("Failed to update Legal Awareness Schedule");
    }
    return response.json();
};
export const createLegalAwarenessFeedback = async (data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_awareness/feedbacks/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: data,
        }
    );
    if (!response.ok) {
        console.log(response);
        throw new Error("Failed to create Legal Awareness request");
    }
    return response.json();
};
export const createLegalAwarenessRespondbackFeedback = async (data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_awareness/respond-backs/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: data,
        }
    );
    if (!response.ok) {
        console.log(response);
        throw new Error("Failed to create Legal Awareness request");
    }
    return response.json();
};

export const createLegalAwarenessZone = async (data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_awareness/distributed-zones/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: data,
        }
    );
    if (!response.ok) {
        console.log(response);
        throw new Error("Failed to create Legal Awareness Zone request");
    }
    return response.json();
};

export const createDistributedTowerData = async (data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_awareness/distributed-tower-data/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: data,
        }
    );
    if (!response.ok) {
        console.log(response);
        throw new Error("Failed to create Distributed Tower Data");
    }
    return response.json();
};

export const updateDistributedTowerData = async (id: number, data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_awareness/distributed-tower-data/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "PATCH",
            body: data,
        }
    );
    if (!response.ok) {
        console.log(response);
        throw new Error("Failed to update Distributed Tower Data");
    }
    return response.json();
};

export const getDistributedTowerDataByAdminUnit = async (adminUnit: string) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_awareness/distributed-tower-data/filter-by-admin-unit/?admin_unit=${adminUnit}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        console.log(response);
        throw new Error("Failed to get Distributed Tower Data by Admin Unit");
    }
    return response.json();
};

export const getAllDistributedTowerData = async () => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_awareness/distributed-tower-data/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        console.log(response);
        throw new Error("Failed to get all Distributed Tower Data");
    }
    return response.json();
};

